import Helpers from "helpers"

document.addEventListener "click", (event) ->
  target = event.target.closest("[data-click-log]")

  if target
    activityLog = JSON.parse target.getAttribute("data-click-log")
    activityLog.params.client_time = (new Date().getTime() / 1000) | 0
    Helpers.logEvent activityLog.url, activityLog.params
